import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import {
  distinctUntilChanged,
  filter,
  skip,
  Subject,
  take,
  takeUntil,
} from 'rxjs';
import { BuscasService } from 'src/app/buscas/service/buscas/buscas.service';
import { FichaObraImpressaoComponent } from 'src/app/ficha-da-obra/ficha-obra-impressao/ficha-obra-impressao.component';
import { ModulosSelecaoService } from 'src/app/filtro-lateral/service/modulos/modulos-selecao-id/modulos-selecao-id.service';
import { ListagemObrasComponent } from 'src/app/home/listagem-obras/listagem-obras.component';
import { ModalAguardandoDownloadComponent } from 'src/app/shared/components/modal-aguardando-download/modal-aguardando-download.component';
import {
  ModalMensagemComponent,
  TipoModalMensagem,
} from 'src/app/shared/components/modal-mensagem/modal-mensagem.component';
import { ModuloSelecionadoService } from 'src/app/shared/components/filtros-busca/service/modulos-service/modulo-selecionado.service';
import {
  getRotaPorModuleId,
  ModuloBusca,
  ModulosBuscaService,
} from 'src/app/shared/components/filtros-busca/service/modulos-service/modulos.service';
import { ResultadoFiltroService } from 'src/app/shared/components/filtros-busca/service/resultado-service/resultado-filtros.service';
import { FooterListagemBuscaComponent } from 'src/app/shared/components/footer-listagem-busca/footer-listagem-busca.component';
import { ModalAvisoAlteracaoRegrasComponent } from 'src/app/shared/components/modais/modal-aviso-alteracao-regras/modal-aviso-alteracao-regras.component';
import { ModalIntencaoSaidaComponent } from 'src/app/shared/components/modais/modal-intencao-saida/modal-intencao-saida.component';
import { ModalNotificacaoObrasComponent } from 'src/app/shared/components/modais/modal-notificacao-obras/modal-notificacao-obras.component';
import {
  COLUNAS_IMOBILIARIO,
  COLUNAS_OUTROS,
} from 'src/app/shared/constants/colunas-tabela-resultados';
import { ObraNavegacaoService } from 'src/app/shared/services/obras-navegacao/obras-navegacao.service';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { environment } from 'src/environments/environment';
import { FiltroBuscaImobiliarioComponent } from '../filtro-busca-imobiliario/filtro-busca-imobiliario.component';
import { FiltroBuscaInfraEdificacoesIndustrialComponent } from '../filtro-busca-infra-edificacoes-industrial/filtro-busca-infra-edificacoes-industrial.component';
import { FiltroBuscaEstadoService } from '../service/filtro-busca-estado.service';
import { PaginacaoFiltrosService } from '../service/paginacao-filtros.service';

export interface Responsible {
  id: number;
  name: string;
}

export interface Task {
  id: number;
  description: string;
}

@Component({
  selector: 'app-resultado-filtros',
  standalone: true,
  imports: [
    CommonModule,
    FiltroBuscaImobiliarioComponent,
    FiltroBuscaInfraEdificacoesIndustrialComponent,
    ListagemObrasComponent,
    ModalAguardandoDownloadComponent,
    ModalMensagemComponent,
    FormsModule,
    ModalIntencaoSaidaComponent,
    FooterListagemBuscaComponent
  ],
  templateUrl: './resultado-filtros.component.html',
  styleUrls: ['./resultado-filtros.component.scss'],
})
export class ResultadoFiltrosComponent implements OnInit {
  userID: string;

  private clickListener: any;
  private moduloIdPendente: number | null = null;

  @Input() menuModules: Array<any> = [];
  @ViewChild(FiltroBuscaImobiliarioComponent)
  filtroImobiliarioComponent!: FiltroBuscaImobiliarioComponent;
  @ViewChild(FiltroBuscaInfraEdificacoesIndustrialComponent)
  filtroIndustrialComponent!: FiltroBuscaInfraEdificacoesIndustrialComponent;
  @ViewChild(ListagemObrasComponent)
  listagemObrasComponent: ListagemObrasComponent;

  isInitialLoad = true;
  BASE_IMG_URL: string = environment.BASE_IMG_URL;
  BASE_URL: string = environment.BASE_IMG_URL;

  termoBusca: string = '';

  tabelaDados: any[] = [];
  tabelaColunas: any[] = [];
  tabelaLoading = false;
  tabelaTotalItems = 0;
  tabelaPage = 1;
  tabelaPageSize = 50;
  private ordenacaoAtual: string = 'date:desc';

  private readonly SORT_TOKEN_MAP: Record<string, string> = {
    obra: 'name',
    empresa: 'company',
    fase: 'phase',
    ufCidade: 'state',
    tipo: 'type',
    tipoObra: 'type',
    padrao: 'pattern',
    valor: 'value',
    responsavel: 'responsible',
    atualizada: 'date',
  };
  filtrosImobiliario: any = {};
  recordCount: number = 0;

  loadingWorks: boolean = false;
  processandoAcao: boolean = false;
  mensagemProcessando: string = 'Aguardando download...';

  modalMensagem: {
    tipo: TipoModalMensagem;
    titulo: string;
    mensagem: string;
  } | null = null;

  idObraSelecionada: number | null = null;
  selectedWorkIds: number[] = [];
  indiceObraAtual: number = 0;

  todayString = new Date().toISOString().split('T')[0];

  selectedOptionAcao: number = 0;
  selectedOption: string = '';
  selectedOptionResponsavel: number = 0;
  selectedDate: string = '';

  bloqueioFiltroImobiliario = false;
  bloqueioFiltroIndustrial = false;

  exibirModalSaida = false;
  exibirModalAvisoRegras = false;

  @ViewChild(ModalAvisoAlteracaoRegrasComponent)
  modalAvisoRegrasComponent?: ModalAvisoAlteracaoRegrasComponent;

  modulosDisponiveis: { [key: number]: boolean } = {};
  temAcessoModulo: boolean = false;
  modulosDisponiveisCarregados = false;

  moduloIDs = {
    Imobiliario: 234,
    Industrial: 5,
    Edificacoes: 6,
    Infraestrutura: 7,
  };

  buscaSalvaId?: number;
  emEdicaoBusca: boolean = false;

  modulos: ModuloBusca[] = [];
  moduloSelecionado: ModuloBusca | null = null;
  private bloqueiaMudancaModuloPorURL = false;
  private hasUserSelectedModulo = false;

  private readonly selecionarIdModulosService = inject(ModulosSelecaoService);
  private destroy$ = new Subject<void>();

  constructor(
    private readonly modulosService: ModulosBuscaService,
    private readonly _resultadoService: ResultadoFiltroService,
    private cdr: ChangeDetectorRef,
    private utilsService: UtilsService,
    private paginacaoService: PaginacaoFiltrosService,
    private readonly modalService: BsModalService,
    private moduloSelecionadoService: ModuloSelecionadoService,
    private router: Router,
    private route: ActivatedRoute,
    private modulosSelecaoService: ModulosSelecaoService,
    private readonly buscasService: BuscasService,
    private readonly obraNavegacaoService: ObraNavegacaoService,
    private readonly filtroBuscaEstado: FiltroBuscaEstadoService,
  ) {
    this.userID = localStorage.getItem('userId') || '';
    this._corrigirLocalStorageEscapado();

    if (this.userID === '233278' || this.userID === '235633') {
      this.exibirModalSaida = true;
    }
  }

  private exibirMensagem(
    tipo: TipoModalMensagem,
    titulo: string,
    mensagem: string,
  ): void {
    this.modalMensagem = { tipo, titulo, mensagem };
  }

  onFecharModalMensagem(): void {
    this.modalMensagem = null;
  }

  ngOnInit() {
    this._registrarEventosHeader();
    this._registrarEventoLimparBuscaSalva();
    this._observarModulosDisponiveis();
    this._observarQueryParams();
    this._observarMudancaModuloManual();
    this._observarPaginacao();
    this._observarSaidaDaBusca();
    this.responsibleFilter();
    this.tasksFilter();
    this._verificarExibirModalAvisoRegras();

    this.clickListener = this.fecharDropdownFora.bind(this);
    document.addEventListener('click', this.clickListener);
  }

  private _observarSaidaDaBusca(): void {
    this.router.events
      .pipe(
        filter(
          (evento): evento is NavigationStart =>
            evento instanceof NavigationStart,
        ),
        takeUntil(this.destroy$),
      )
      .subscribe((evento) => {
        if (this._urlPertenceAoFluxoDeBusca(evento.url)) return;

        Object.values(this.moduloIDs).forEach((moduloId) =>
          this.filtroBuscaEstado.limpar(moduloId),
        );
      });
  }

  private _urlPertenceAoFluxoDeBusca(url: string): boolean {
    const caminho = url.split('?')[0];
    return /^\/buscas\/(imobiliario|industrial|edificacoes|infraestrutura)(\/|$)/.test(
      caminho,
    );
  }

  private _observarPaginacao(): void {
    this.paginacaoService.paginacao$
      .pipe(takeUntil(this.destroy$))
      .subscribe((pag) => {
        if (pag) {
          this.tabelaPage = pag.page ?? this.tabelaPage;
          this.tabelaPageSize = pag.pageSize ?? this.tabelaPageSize;
          if (pag.ordenation) {
            this.ordenacaoAtual = pag.ordenation;
          }
          this.cdr.detectChanges();
        }
      });
  }

  private _registrarEventosHeader(): void {
    window.addEventListener('headerModuloSelecionado', (e: any) => {
      const idModulo =
        e?.detail?.idModulo || e?.detail?.id || e?.idModulo || e?.id;
      if (!idModulo) return;

      this.hasUserSelectedModulo = true;
      this.bloqueiaMudancaModuloPorURL = false;

      this.selecionarModuloPorId(Number(idModulo));
      this.cdr.detectChanges();
    });
  }

  private _registrarEventoLimparBuscaSalva(): void {
    window.addEventListener('limparBuscaSalvaAntesModulo', () => {
      this.buscaSalvaId = undefined;
      this.emEdicaoBusca = false;

      if (this.filtroImobiliarioComponent) {
        this.filtroImobiliarioComponent.limparBuscaSalvaEstado();
      }
    });
  }

  private _observarQueryParams(): void {
    const win: any = window;

    this.route.queryParams
      .pipe(takeUntil(this.destroy$), distinctUntilChanged())
      .subscribe((params) => {
        const moduleIDFromUrl = this._extrairModuloDaURL(params, win);

        if (params['termo']) {
          this.termoBusca = params['termo'];
          this.cdr.detectChanges();
        }

        this._carregarModulosESelecionar(moduleIDFromUrl, params, win);
      });
  }

  private _observarModulosDisponiveis(): void {
    this.modulosSelecaoService.modulosDisponiveis$
      .pipe(takeUntil(this.destroy$))
      .subscribe((modulos) => {
        if (modulos === null) return;

        this.modulosDisponiveis = Array.isArray(modulos)
          ? modulos.reduce(
              (acc, m) => {
                if (m?.moduleID) acc[m.moduleID] = true;
                return acc;
              },
              {} as Record<number, boolean>,
            )
          : modulos || {};

        this.modulosDisponiveisCarregados = true;
        this.verificarAcessoModulo();
        this.cdr.detectChanges();
      });
  }

  private _extrairModuloDaURL(params: any, win: any): number | null {
    const idSelecionadoASP = win.idSelecionadoASP
      ? Number(win.idSelecionadoASP)
      : null;
    const urlSegments = this.route.snapshot.url;
    let idFromRota: number | null = null;

    if (urlSegments.length >= 2 && urlSegments[0].path === 'buscas') {
      const rotaNome = urlSegments[1].path;
      idFromRota = this.modulosService.getIdByRota(rotaNome);
    }

    const id =
      idFromRota ||
      (params['id'] && Number(params['id'])) ||
      (params['moduleID'] && Number(params['moduleID'])) ||
      (this.route.snapshot.paramMap.get('id') &&
        Number(this.route.snapshot.paramMap.get('id'))) ||
      idSelecionadoASP;

    return id && id > 0 ? id : null;
  }

  private _carregarModulosESelecionar(
    moduleIDFromUrl: number | null,
    params: any,
    win: any,
  ): void {
    this.modulosService
      .getModulos()
      .pipe(take(1))
      .subscribe((modulos) => {
        this.modulos = modulos;

        const moduloParaSelecionar =
          this._determinarModuloInicial(moduleIDFromUrl);

        this._aplicarModuloSelecionado(moduloParaSelecionar);

        this._processarBuscaSalva(params, win);
      });
  }

  private _determinarModuloInicial(moduleIDFromUrl: number | null): number {
    if (moduleIDFromUrl && !this.hasUserSelectedModulo) {
      this.bloqueiaMudancaModuloPorURL = true;
      this.moduloIdPendente = moduleIDFromUrl;
      return moduleIDFromUrl;
    }

    this.bloqueiaMudancaModuloPorURL = false;

    return Number(this.moduloSelecionadoService.getModuloSelecionado());
  }

  private _aplicarModuloSelecionado(idModulo: number): void {
    const moduloEncontrado =
      this._resolverModuloSelecionado(idModulo) || this.modulos[0];

    this.moduloSelecionado = moduloEncontrado;
    this.moduloSelecionadoService.setModuloSelecionado(moduloEncontrado.value);

    this.definirColunasPorModulo(moduloEncontrado.value);
    this.verificarAcessoModulo();
    this.cdr.detectChanges();

    this.showNotificationModal();
  }

  private _resolverModuloSelecionado(id: number): ModuloBusca | null {
    if (this.moduloIdPendente !== null) {
      const modulo = this.modulos.find(
        (m) => Number(m.value) === this.moduloIdPendente,
      );
      if (modulo) {
        this.moduloIdPendente = null;
        return modulo;
      }
      console.warn(
        '[MODULO] ID pendente não encontrado:',
        this.moduloIdPendente,
      );
    }

    return this.modulos.find((m) => Number(m.value) === Number(id)) || null;
  }

  private _processarBuscaSalva(params: any, win: any): void {
    const raw =
      params['buscaSalvaId'] ||
      params['idBusca'] ||
      (win.idBuscaASP ? Number(win.idBuscaASP) : null);

    if (raw && Number(raw) > 0) {
      this.buscaSalvaId = Number(raw);
      setTimeout(() => {
        this.aplicarBuscaSalvaPorModulo(this.buscaSalvaId!);
        this.bloqueiaMudancaModuloPorURL = false;
      }, 80);
    } else {
      this.bloqueiaMudancaModuloPorURL = false;
    }
  }

  private _observarMudancaModuloManual(): void {
    this.moduloSelecionadoService.moduloSelecionado$
      .pipe(takeUntil(this.destroy$), skip(1), distinctUntilChanged())
      .subscribe((id) => {
        this.moduloSelecionado =
          this.modulos.find((m) => m.value === id) || this.modulos[0];

        this.definirColunasPorModulo(this.moduloSelecionado.value);
        this.verificarAcessoModulo();
        this.resetarEstadoTabela();
        this.showNotificationModal();
      });
  }
  ngOnDestroy() {
    document.removeEventListener('click', this.clickListener ?? (() => {}));

    this.destroy$.next();
    this.destroy$.complete();
  }

  private resetarEstadoTabela() {
    this.tabelaDados = [];
    this.selectedWorkIds = [];
    this.recordCount = 0;
    this.tabelaTotalItems = 0;
    this.tabelaPage = 1;
    this.tabelaLoading = false;
    this.idObraSelecionada = null;

    this.cdr.detectChanges();
  }

  private aplicarBuscaSalvaPorModulo(buscaSalvaId: number): void {
    const moduloAtual = this.moduloSelecionado?.value;
    this.emEdicaoBusca = true;
    if (moduloAtual === this.moduloIDs.Imobiliario) {
      if (this.filtroImobiliarioComponent) {
        this.filtroImobiliarioComponent.popularBuscaSalvaPorId(buscaSalvaId);
      } else {
        console.warn('Componente imobiliário ainda NÃO está carregado.');
      }

      return;
    }
    if (
      [
        this.moduloIDs.Industrial,
        this.moduloIDs.Edificacoes,
        this.moduloIDs.Infraestrutura,
      ].includes(moduloAtual)
    ) {
      if (this.filtroIndustrialComponent) {
        this.filtroIndustrialComponent.popularBuscaSalvaPorId(buscaSalvaId);
      } else {
        console.warn('⚠️ Componente industrial ainda NÃO está carregado.');
      }

      return;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['temAcessoModulo']) {
      this.temAcessoModulo = changes['temAcessoModulo'].currentValue;
    }

    this.modulosDisponiveis = {
      [this.moduloIDs.Imobiliario]: false,
      [this.moduloIDs.Industrial]: false,
      [this.moduloIDs.Edificacoes]: false,
      [this.moduloIDs.Infraestrutura]: false,
    };

    this.menuModules.forEach((modulo) => {
      if (this.modulosDisponiveis.hasOwnProperty(modulo.moduleID)) {
        this.modulosDisponiveis[modulo.moduleID] = true;
      }
    });

    this.verificarAcessoModulo();
  }

  @Input() set temAcessoModuloInput(val: boolean) {
    this.temAcessoModulo = val;
  }

  private verificarAcessoModulo(): void {
    if (
      this.moduloSelecionado &&
      this.moduloSelecionado.value !== null &&
      this.moduloSelecionado.value !== undefined
    ) {
      this.temAcessoModulo =
        this.modulosDisponiveis[this.moduloSelecionado.value] || false;

      if (!this.temAcessoModulo) {
        console.warn('[ACESSO] Usuário sem acesso ao módulo selecionado');
      }
    } else {
      this.temAcessoModulo = false;
    }
  }

  private _corrigirLocalStorageEscapado(): void {
    const key = 'filtros_busca_imobiliario';
    const raw = localStorage.getItem(key);

    if (!raw) return;
    const pareceEscapado = raw.startsWith('"[') || raw.includes('\\"');

    if (pareceEscapado) {
      try {
        const fixed = JSON.parse(JSON.parse(raw));
        if (Array.isArray(fixed)) {
          localStorage.setItem(key, JSON.stringify(fixed));
        }
      } catch (e) {
        console.warn(
          '[FixStorage] Não foi possível corrigir valor escapado:',
          e,
          raw,
        );
      }
    }
  }

  onResultadoImobiliarioChange(res: any) {
    if (this.bloqueioFiltroImobiliario) return;
    if (res?.error) {
      this.tabelaDados = [];
      this.tabelaTotalItems = 0;
      this.recordCount = 0;
      this.tabelaLoading = false;
      this.loadingWorks = false;
      this.cdr.detectChanges();
      return;
    }
    this.tabelaDados = Array.isArray(res?.data?.records)
      ? res.data.records.map((item: any) => ({
          id: item.id,
          companyID: item.companies?.id ?? null,
          moduleId: this.moduloSelecionado?.value ?? null,
          ufCidade: item.address?.stateAndCity || '',
          empresa: item.companies?.name || '',
          obra: item.name || '',
          fase: item.phaseDescription || '',
          tipo: item.typeDescription || '',
          padrao: item.patternDescription || '',
          responsavel: item.responsibleName || '',
          atualizada: item.updateDateFormat || '',
        }))
      : [];
    this.selectedWorkIds = [];
    this.tabelaTotalItems =
      res?.data?.recordsCount || this.tabelaDados.length || 0;
    this.recordCount = res?.data?.recordsCount;
    this.tabelaLoading = false;
    this.loadingWorks = false;
    this.cdr.detectChanges();
  }

  dropdownAberto = false;
  abrirOuFecharDropdown(event: MouseEvent) {
    event.stopPropagation();
    this.dropdownAberto = !this.dropdownAberto;
  }

  listTasks: Task[] = [];
  listResponsible: Responsible[] = [];
  filtros = {
    tarefa: '',
    data: '',
    responsavel: '',
  };

  private definirColunasPorModulo(moduloValue: number | undefined) {
    const removerModulo = (col: any) =>
      col.key !== 'modulo' && col.key !== 'modulos' && col.label !== 'MÓDULO';
    if (moduloValue === 234) {
      this.tabelaColunas = COLUNAS_IMOBILIARIO.filter(removerModulo);
    } else {
      this.tabelaColunas = COLUNAS_OUTROS.filter(removerModulo);
    }
  }
  onTabelaPageChange(page: number) {
    this.tabelaPage = page;
    this.paginacaoService.setPaginacao({
      page,
      pageSize: this.tabelaPageSize,
      ordenation: this.ordenacaoAtual,
    });
  }

  onTabelaPageSizeChange(pageSize: number) {
    this.tabelaPageSize = pageSize;
    this.tabelaPage = 1;
    this.paginacaoService.setPaginacao({
      page: 1,
      pageSize,
      ordenation: this.ordenacaoAtual,
    });
    if (this.moduloSelecionado?.value === 234) {
      if (this.filtroImobiliarioComponent) {
        this.filtroImobiliarioComponent.atualizarPaginacao(
          1,
          pageSize,
          this.ordenacaoAtual,
        );
      }
    } else if ([5, 6, 7].includes(this.moduloSelecionado?.value)) {
      if (this.filtroIndustrialComponent) {
        this.filtroIndustrialComponent.atualizarPaginacao(
          1,
          pageSize,
          this.ordenacaoAtual,
        );
      }
    }
  }

  onTabelaSortChange(event: { column: string; direction: 'asc' | 'desc' }) {
    const { column, direction } = event;
    if (column === 'id') return;

    const token = this.SORT_TOKEN_MAP[column];
    if (!token) {
      console.warn(
        '[ORDENACAO] Coluna sem token de ordenação mapeado na whitelist da API:',
        column,
      );
      return;
    }

    this.ordenacaoAtual = `${token}:${direction}`;
    this.tabelaPage = 1;

    this.paginacaoService.setPaginacao({
      page: 1,
      pageSize: this.tabelaPageSize,
      ordenation: this.ordenacaoAtual,
    });
  }

  onTabelaSelectionChange(selection: any[]) {
    this.selectedWorkIds = selection.map((o) => o.id);
    selection.forEach((obra: any) => {});
  }

  onModuloDropdownSelect(modulo: ModuloBusca) {
    this.hasUserSelectedModulo = true;
    this.bloqueiaMudancaModuloPorURL = false;

    this.moduloSelecionadoService.setModuloSelecionado(modulo.value);
    this.dropdownAberto = false;
  }

  public selecionarModuloPorId(idModulo: number): void {
    if (!idModulo || isNaN(Number(idModulo))) {
      console.warn('[MODULO] ID inválido recebido:', idModulo);
      return;
    }

    this.hasUserSelectedModulo = true;
    this.bloqueiaMudancaModuloPorURL = true;

    const moduloEncontrado = this.modulos.find(
      (m) => Number(m.value) === Number(idModulo),
    );

    if (!moduloEncontrado) {
      console.warn('[MODULO] Nenhum módulo encontrado para ID:', idModulo);
      return;
    }

    this.moduloSelecionado = moduloEncontrado;
    this.moduloSelecionadoService.setModuloSelecionado(moduloEncontrado.value);

    this.definirColunasPorModulo(moduloEncontrado.value);
    this.verificarAcessoModulo();
    this.resetarEstadoTabela();
    this.showNotificationModal();

    this.cdr.detectChanges();
  }

  public fecharDropdownFora(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.modulo-dropdown-wrapper')) {
      this.dropdownAberto = false;
    }
  }

  responsibleFilter(): void {
    this._resultadoService.getWorkResponsibles().subscribe(
      (response) => {
        const arr = (response.data || []).map((r: any) => ({
          id: r.id,
          name: r.name,
        }));
        this.listResponsible = this.utilsService.sortArray(
          arr,
          'name',
          'alpha',
        );
      },
      (error) => {
        console.error('Erro ao buscar responsáveis:', error);
      },
    );
  }

  tasksFilter(): void {
    this._resultadoService.getActions().subscribe(
      (response) => {
        const arr = (response.data || []).map((t: any) => ({
          id: t.id,
          description: t.description,
        }));
        this.listTasks = this.utilsService.sortArray(
          arr,
          'description',
          'alpha',
        );
      },
      (error) => {
        console.error('Erro ao buscar tarefas:', error);
      },
    );
  }

  private _verificarExibirModalAvisoRegras(): void {
    const storageKey = this.userID
      ? `modal_alteracao_regras_visualized_${this.userID}`
      : 'modal_alteracao_regras_visualized';
    const hasVisualized = localStorage.getItem(storageKey);
    if (!hasVisualized) {
      this.exibirModalAvisoRegras = true;
    }
  }

  fecharModalAvisoRegras(): void {
    this.exibirModalAvisoRegras = false;
  }

  abrirFichaObra(workID: number): void {
    if (!workID) {
      console.error('workID inválido.');
      return;
    }

    const ids = this.tabelaDados.map((o) => o.id);
    if (!ids.length) {
      console.error('Lista de obras vazia.');
      return;
    }

    const nomeModulo = this.route.snapshot.url[1]?.path ?? '';

    this.obraNavegacaoService.setObraIds(ids, nomeModulo);
    this.router.navigate(['/buscas', nomeModulo, 'detalhes', workID]);
  }

  limparSelecaoObras() {
    this.selectedWorkIds = [];
    if (this.listagemObrasComponent) {
      this.listagemObrasComponent.limparSelecao();
    }
  }

  get podeEditarAcao(): boolean {
    return this.temAcessoModulo || this.emEdicaoBusca;
  }

  updateWork(): void {
    let idsSelecionados: any = [];
    let workID: string | null = null;
    if (this.selectedWorkIds && this.selectedWorkIds.length === 1) {
      idsSelecionados = [this.selectedWorkIds[0]];
      workID = String(this.selectedWorkIds[0]);
    } else if (this.selectedWorkIds && this.selectedWorkIds.length > 1) {
      idsSelecionados = this.selectedWorkIds;
      workID = idsSelecionados.join(',');
    }

    if (!this.moduloSelecionado || !this.moduloSelecionado.value) {
      console.error(
        'Erro: moduleID está null. Verifique a lógica de inicialização.',
      );
      return;
    }

    if (!idsSelecionados || idsSelecionados.length === 0) {
      this.exibirMensagem(
        'atencao',
        'Atenção',
        'Por favor, selecione pelo menos uma obra para atualizar.',
      );
      return;
    }

    if (
      !this.selectedOptionAcao ||
      !this.selectedOptionResponsavel ||
      !this.selectedDate
    ) {
      this.exibirMensagem(
        'atencao',
        'Atenção',
        'Por favor, preencha todos os campos de ação antes de atualizar.',
      );
      return;
    }

    const filtro: any = {
      moduleID: this.moduloSelecionado.value,
      taskID: this.selectedOptionAcao,
      responsibleID: this.selectedOptionResponsavel,
      followUpDate: this.selectedDate
        ? new Date(this.selectedDate).toISOString()
        : null,
      workID: workID,
    };

    this._resultadoService.updateListing(filtro).subscribe({
      next: (response) => {
        this.selectedOptionAcao = 0;
        this.selectedOptionResponsavel = 0;
        this.selectedDate = '';
        this.selectedWorkIds = [];

        if (this.filtroIndustrialComponent) {
          this.filtroIndustrialComponent.resetUltimoBody();
        }

        this.paginacaoService.setPaginacao({
          page: this.tabelaPage,
          pageSize: this.tabelaPageSize,
          ordenation: this.ordenacaoAtual,
        });
        this.exibirMensagem('sucesso', 'Sucesso!', 'Obras atualizadas com sucesso!');
      },
      error: (error) => {
        console.error('Erro ao atualizar listagem', error);
        this.exibirMensagem('erro', 'Erro', 'Erro ao atualizar. Tente novamente.');
      },
    });
  }

  onResultadoIndustrialChange(res: any) {
    if (this.bloqueioFiltroIndustrial) return;
    if (res?.error) {
      this.tabelaDados = [];
      this.tabelaTotalItems = 0;
      this.recordCount = 0;
      this.tabelaLoading = false;
      this.loadingWorks = false;
      this.cdr.detectChanges();
      return;
    }
    this.tabelaDados = Array.isArray(res?.data?.records)
      ? res.data.records.map((item: any) => ({
          id: item.id,
          companyID: item.companies?.id ?? null,
          moduleId: this.moduloSelecionado?.value ?? null,
          ufCidade: item.address?.stateAndCity || '',
          empresa: item.companies?.name || '',
          obra: item.name || '',
          fase: item.phaseDescription || '',
          valor: item.valueDolar || '',
          tipoObra: item.typeDescription || '',
          responsavel: item.responsibleName || '',
          atualizada: item.updateDateFormat || '',
        }))
      : [];
    this.selectedWorkIds = [];
    this.tabelaTotalItems =
      res?.data?.recordsCount || this.tabelaDados.length || 0;
    this.recordCount = res?.data?.recordsCount;
    this.tabelaLoading = false;
    this.loadingWorks = false;
    this.cdr.detectChanges();
  }

  downloadPDFFicha(): void {
    if (!this.selectedWorkIds || this.selectedWorkIds.length === 0) {
      this.exibirMensagem('atencao', 'Atenção', 'Selecione pelo menos uma obra para exportar PDF.');
      return;
    }

    this.mensagemProcessando = 'Aguardando download do PDF...';
    this.processandoAcao = true;
    const body = {
      workDetails: this.selectedWorkIds.map((id) => ({
        workId: String(id),
        moduleId: String(this.moduloSelecionado?.value || 0),
      })),
    };
    this._resultadoService.downloadPDF(body).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Ficha-da-obra.pdf`;
        a.click();
        window.URL.revokeObjectURL(url);
        this.processandoAcao = false;
        this.limparSelecaoObras();
      },
      error: (err) => {
        console.error('Erro ao baixar o PDF:', err);
        this.processandoAcao = false;
      },
    });
  }

  impressaoFicha(): void {
    if (!this.selectedWorkIds || this.selectedWorkIds.length === 0) {
      this.exibirMensagem('atencao', 'Atenção', 'Selecione pelo menos uma obra para imprimir.');
      return;
    }

    this.mensagemProcessando = 'Processando impressão...';
    this.processandoAcao = true;
    const body = {
      workDetails: this.selectedWorkIds.map((id) => ({
        workId: String(id),
        moduleId: String(this.moduloSelecionado?.value || 0),
      })),
    };
    this._resultadoService.printWorks(body).subscribe({
      next: (response) => {
        this.processandoAcao = false;
        if (response.success && response.data.works.length > 0) {
          const modalRef = this.modalService.show(FichaObraImpressaoComponent, {
            initialState: {
              dadosApi: response.data,
            },
            class: 'modal-lg',
          });
          if (modalRef.content) {
            modalRef.content.modalRef = modalRef;
          }
          this.limparSelecaoObras();
        } else {
          console.error('Nenhuma obra encontrada na resposta:', response);
        }
      },
      error: (error) => {
        this.processandoAcao = false;
        console.error('Erro ao buscar detalhes da impressão:', error);
      },
    });
  }

  exportExcel(): void {
    if (!this.selectedWorkIds || this.selectedWorkIds.length === 0) {
      this.exibirMensagem('atencao', 'Atenção', 'Por favor selecione as obras para exportar.');
      return;
    }
    const workID = this.selectedWorkIds.join(',');
    const moduleIdFilter = this.moduloSelecionadoService.getModuloSelecionado();

    this.mensagemProcessando = 'Aguardando download do Excel...';
    this.processandoAcao = true;
    this.buscasService.exportWorksCompany(workID, moduleIdFilter).subscribe(
      (response) => {
        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'exportar-obras.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.processandoAcao = false;

        this.limparSelecaoObras();
      },
      (error) => {
        this.processandoAcao = false;
        console.error('Erro ao exportar Excel:', error);
      },
    );
  }
  onAbrirEmpresa(empresa: any) {
    const empresaId = empresa.companyID;
    const moduloId = Number(
      empresa.moduleId ?? this.moduloSelecionado?.value ?? 0,
    );

    if (empresaId && moduloId) {
      const rota = getRotaPorModuleId(moduloId);
      this.router.navigate(['/empresas/detalhes', rota, empresaId]);
      return;
    }

    const termo = empresa.companyName || empresa.empresa || empresa.name || '';
    if (!termo) {
      console.warn('Nome da empresa não encontrado no objeto:', empresa);
      return;
    }

    this.router.navigate(['/empresas'], { queryParams: { termo } });
  }

  showNotificationModal(): void {
    if (!('Notification' in window)) return;

    if (Notification.permission === 'default') {
      const allowedModuloIds = [
        this.moduloIDs.Imobiliario,
        this.moduloIDs.Industrial,
        this.moduloIDs.Edificacoes,
        this.moduloIDs.Infraestrutura,
      ];

      if (
        !this.moduloSelecionado ||
        !allowedModuloIds.includes(this.moduloSelecionado.value)
      ) {
        return;
      }

      const dismissedDate = localStorage.getItem(
        'notificationPromptDismissedDate',
      );
      const dismissedDateLong = localStorage.getItem(
        'notificationPromptDismissedDateLong',
      );

      if (dismissedDate) {
        const dismissedTime = new Date(dismissedDate).getTime();
        const currentTime = new Date().getTime();
        const twoDaysInMs = 2 * 24 * 60 * 60 * 1000;

        if (currentTime - dismissedTime < twoDaysInMs) {
          return;
        }
      }

      if (dismissedDateLong) {
        const dismissedTime = new Date(dismissedDateLong).getTime();
        const currentTime = new Date().getTime();
        const fourDaysInMs = 4 * 24 * 60 * 60 * 1000;

        if (currentTime - dismissedTime < fourDaysInMs) {
          return;
        }
      }

      const sessionKey = 'notificationModalShownInSession';
      const permissionKey = 'notificationPermissionState';

      const savedPermission = localStorage.getItem(permissionKey);
      const currentPermission = Notification.permission;

      if (
        savedPermission &&
        savedPermission !== 'default' &&
        currentPermission === 'default'
      ) {
        sessionStorage.removeItem(sessionKey);
        localStorage.removeItem(permissionKey);
      }

      if (sessionStorage.getItem(sessionKey)) {
        return;
      }

      sessionStorage.setItem(sessionKey, 'true');
      localStorage.setItem(permissionKey, currentPermission);

      this.modalService.show(ModalNotificacaoObrasComponent, {
        class: 'modal-dialog-centered modal-notification-permission',
        keyboard: false,
        ignoreBackdropClick: true,
        backdrop: true,
      });
    } else {
      localStorage.setItem(
        'notificationPermissionState',
        Notification.permission,
      );
    }
  }
}
